export default (node) => {
  const searchInput = node.querySelector('[data-input="searchResultsInput"]');
  const actionButton = node.querySelector('[data-action="clearOrSearch"]');
  const searchIcon = actionButton.querySelector('[data-icon="searchIcon"]');
  const clearText = actionButton.querySelector('[data-clear-text="clearText"]');

  const handleInputChange = () => {
    if (searchInput.value.trim() !== '') {
      // Show "CLEAR" and hide search icon
      actionButton.type = 'button';
      searchIcon.classList.add('hidden');
      clearText.classList.remove('hidden');
    } else {
      // Reset to search state
      actionButton.type = 'submit';
      searchIcon.classList.remove('hidden');
      clearText.classList.add('hidden');
    }
  };

  const clearSearch = () => {
    if (clearText.classList.contains('hidden') === false) {
      searchInput.value = '';
      handleInputChange();
      searchInput.focus();
    }
  };

  // Event listeners
  searchInput.addEventListener('input', handleInputChange);
  actionButton.addEventListener('click', () => {
    if (clearText.classList.contains('hidden') === false) {
      clearSearch();
    }
  });

  // Initialize state
  handleInputChange();
};
